export default __webpack_public_path__ + "static/media/Picture15.8f95dcfc.png";